import {createFeature, createReducer, on} from '@ngrx/store';
import {FeatureStoreNames} from '@shared-types';

import {metaTagsActions} from './meta-tags.actions';
import {metaTagsAdapter, MetaTagsStore} from './meta-tags.models';
import {selectAll} from './meta-tags.selectors';

import metaTagsInitialState = MetaTagsStore.metaTagsInitialState;
import IMetaTagsState = MetaTagsStore.IMetaTagsState;
export const metaTagsFeature = createFeature({
	name: FeatureStoreNames.META_TAGS_FEATURE_KEY,
	reducer: createReducer(
		{...metaTagsInitialState},
		on(metaTagsActions.loadMetaTags, state => ({...state, error: undefined, loading: true})),
		on(metaTagsActions.reloadMetaTags, state => ({...state, error: undefined, loading: true})),
		on(metaTagsActions.loadMetaTagsSuccess, (state, {metaTags}) => {
			return metaTagsAdapter.upsertMany(metaTags, {...state, loading: false, loaded: true});
		}),
		on(metaTagsActions.loadMetaTagsFailure, (state, {error}) => ({...state, error: error, loading: false, loaded: false})),
		on(metaTagsActions.addMetaTag, state => ({...state, error: undefined, loading: true})),
		on(metaTagsActions.addMetaTagSuccess, (state, {newMetaTag}) => {
			return metaTagsAdapter.setAll([newMetaTag, ...selectAll(state)], {...state, loading: false, loaded: true});
		}),
		on(metaTagsActions.addMetaTagFailure, (state, {error}) => ({...state, error: error, loading: false, loaded: false})),
		on(metaTagsActions.deleteMetaTag, state => ({...state, error: undefined, loading: true})),
		on(metaTagsActions.deleteMetaTagSuccess, (state, {metaTagKey}) => {
			return metaTagsAdapter.removeOne(metaTagKey, {...state, loading: false, loaded: true});
		}),
		on(metaTagsActions.deleteMetaTagFailure, (state, {error}) => ({...state, error: error, loading: false, loaded: false})),
		on(metaTagsActions.updateMetaTag, state => ({...state, error: undefined, loading: true})),
		on(metaTagsActions.updateMetaTagSuccess, (state, {updatedMetaTag}) => {
			return metaTagsAdapter.setAll([updatedMetaTag, ...selectAll(state)], {...state, loading: false, loaded: true});
		}),
		on(metaTagsActions.updateMetaTagFailure, (state, {error}) => ({...state, error: error, loading: false, loaded: false})),
	),
});

export function metaTagsReducer(state: IMetaTagsState | undefined, action: any): IMetaTagsState {
	return metaTagsFeature.reducer(state, action);
}
